import { CssFieldDefinition } from "@/components/RightStyle";
import {
  EXTRACT_TAILWIND_DISPLAY_REGEX,
  PropertyType,
} from "@/hooks/useTailwindProperties";
import { useEffect, useState } from "react";

/**
 * @param enhancedDisplay if set to true, the value is converted to the matching tailwind class based on the
 * css selector source (e.g. bg-blue-300 will set the value to blue-300)
 */
export const usePropertyState = (
  property: CssFieldDefinition,
  evaluated: boolean,
  type?: PropertyType,
  enhancedDisplay?: boolean
) => {
  const getValueFromProperty = () => {
    if (
      enhancedDisplay &&
      // @ts-expect-error TS2538
      PropertyType[type] !== null &&
      property.cssSelectorSource?.startsWith(".") &&
      // @ts-expect-error TS2538
      EXTRACT_TAILWIND_DISPLAY_REGEX[type]
    ) {
      const tailwindClass = property.cssSelectorSource.slice(1);

      const regMatches = tailwindClass?.match(
        // @ts-expect-error TS2538
        EXTRACT_TAILWIND_DISPLAY_REGEX[type]
      );
      const firstGroupMatch = Array.from(regMatches || [])?.[1];
      if (firstGroupMatch) {
        return firstGroupMatch;
      }
    }

    return (evaluated ? property?.evaluatedValue : property?.value) || "";
  };

  const [value, setValue] = useState(getValueFromProperty());
  const [isSet, setIsSet] = useState(property?.set || false);

  useEffect(() => {
    setValue(getValueFromProperty());
  }, [
    property.cssSelectorSource,
    evaluated ? property?.evaluatedValue : property?.value,
  ]);

  useEffect(() => {
    setIsSet(property?.set || false);
  }, [property?.set]);

  return [value, setValue, isSet, setIsSet];
};
